import { render } from "./AgroExporter.vue?vue&type=template&id=8f2c7b14"
import script from "./AgroExporter.vue?vue&type=script&lang=js"
export * from "./AgroExporter.vue?vue&type=script&lang=js"

import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__